import styled from 'styled-components';
import css from '@styled-system/css';

export const StyledImage = styled.img(
  css({
    visibility: 'hidden',
    maxWidth: '100%',
  })
);
